<template>
  <div class="overflow-hidden bg-gray p-2">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <iframe v-if="file" class="pdf" :src="'data:application/pdf;base64,'+(file as any).Base64FileStream">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  file: Object
});
</script>
